<!--微信登录授权界面-->
<template>
  <div class="page-wx-confirm">
    <img src="../../../assets/img/ic_wx_confirm_.png">
    <div class="button1 login" @click="onWxLogin">
      <img src="../../../assets/img/ic_wx_white.png">
      微信用户一键登录
    </div>
    <div class="tip">
      <van-icon name="checked" color="#07c160" />
      <span style="margin-left: 0.1rem">获得你的公开信息(昵称、头像等)</span>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';
export default {
  components: {
    [Icon.name]: Icon
  },
  data () {
    return {
      oprPkId: ''
    };
  },

  created () {
  },
  computed: {},

  methods: {
    onWxLogin () {
      this.oprPkId = this.$common.query('oprPkId');
      this.$router.replace({name: 'wx', query: {oprPkId: this.oprPkId,replace: true}});
    }
  }
};


</script>

<style lang="less" scoped>
.page-wx-confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.28rem;
  img:first-child {
    width: 4.6rem;
    height: 2.34rem;
  }
  .login {
    display: flex;
    align-items: center;
    width: 90%;
    margin: 0.8rem 0 0.3rem 0;
    img {
      width: 0.41rem;
      height: 0.32rem;
      margin-right: 0.2rem;
    }
  }
  .tip {
    display: flex;
    align-items: center;
  }
}
</style>
